import { render, staticRenderFns } from "./WhyBEX.vue?vue&type=template&id=3fe11ce8&"
import script from "./WhyBEX.vue?vue&type=script&lang=js&"
export * from "./WhyBEX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports